import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { H3 } from '@jetbrains/ring-ui/components/heading/heading';
import { assignTestId } from '@app/common/infra/tests/assign-test-id';
import styles from './titled-block.css';
export function TitledBlock(props) {
    const { className, children, title, titleLogo, ...rest } = props;
    return (_jsxs("section", { className: classNames(styles.wrapper, className), ...assignTestId('titled-block', rest), children: [_jsxs("header", { className: styles.sectionHeader, ...assignTestId('titled-block-header'), children: [titleLogo && _jsx("span", { className: styles.logoWrapper, children: titleLogo }), _jsx(H3, { className: styles.h3, ...assignTestId('titled-block', 'title'), children: title })] }), _jsx("div", { className: styles.blockContent, children: children })] }));
}
